import type { AdminNotificationDto } from "@/api/types";
import { Bell01Icon } from "@/components/Icons/Bell01Icon";
import { Mail01Icon } from "@/components/Icons/Mail01Icon";
import { MessageSquare02Icon } from "@/components/Icons/MessageSquare02Icon";
import { Tool02Icon } from "@/components/Icons/Tool02Icon";

export function NotificationIcon({ type }: { type: AdminNotificationDto["type"] }): React.ReactNode {
  switch (type) {
    case "message":
    case "groupMessage":
      return <Mail01Icon size={20} />;
    case "messageComment":
      return <MessageSquare02Icon size={20} />;
    case "ticket":
    case "ticketAssignee":
    case "ticketComment":
      return <Tool02Icon size={20} />;
    default:
      return <Bell01Icon size={20} />;
  }
}
